const EMBED_FLAG_KEY = "ikaro_embed_mode";
const EMBED_LISTING_QUERY_KEY = "ikaro_embed_listing_query";
const EMBED_LIST_MODE_KEY = "ikaro_embed_list_mode";
const EMBED_CELL_ID_KEY = "ikaro_embed_cell_id";

export const EMBED_KEY_HEADER = "X-Embed-Key";

export const EMBED_LIST_MODE_ALL = "all";
export const EMBED_LIST_MODE_USER_ACTIVE = "user_active";
export const EMBED_LIST_MODE_HUMAN_ACTION = "human_action";

export function isEmbedMode() {
  try {
    return sessionStorage.getItem(EMBED_FLAG_KEY) === "1";
  } catch {
    return false;
  }
}

export function getEmbedListMode() {
  try {
    return sessionStorage.getItem(EMBED_LIST_MODE_KEY) || EMBED_LIST_MODE_ALL;
  } catch {
    return EMBED_LIST_MODE_ALL;
  }
}

/** Query params fixos enviados a /job/get_jobs_list no modo embed. */
export function getEmbedListingQuery() {
  try {
    const raw = sessionStorage.getItem(EMBED_LISTING_QUERY_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function getEmbedCellId() {
  try {
    const raw = sessionStorage.getItem(EMBED_CELL_ID_KEY);
    if (!raw) return null;
    const parsed = parseInt(raw, 10);
    return Number.isFinite(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function persistEmbedSession({
  listingQuery = {},
  listMode = EMBED_LIST_MODE_ALL,
  cellId = null,
} = {}) {
  try {
    sessionStorage.setItem(EMBED_FLAG_KEY, "1");
    sessionStorage.setItem(EMBED_LIST_MODE_KEY, listMode || EMBED_LIST_MODE_ALL);
    sessionStorage.setItem(
      EMBED_LISTING_QUERY_KEY,
      JSON.stringify(listingQuery || {}),
    );
    if (cellId != null) {
      sessionStorage.setItem(EMBED_CELL_ID_KEY, String(cellId));
    } else {
      sessionStorage.removeItem(EMBED_CELL_ID_KEY);
    }
  } catch {
    // sessionStorage indisponível (ex.: modo privado restrito)
  }
}

export function clearEmbedSession() {
  try {
    sessionStorage.removeItem(EMBED_FLAG_KEY);
    sessionStorage.removeItem(EMBED_LISTING_QUERY_KEY);
    sessionStorage.removeItem(EMBED_LIST_MODE_KEY);
    sessionStorage.removeItem(EMBED_CELL_ID_KEY);
    sessionStorage.removeItem("ikaro_embed_filters");
  } catch {
    // noop
  }
}

export function buildEmbedDestination(path) {
  const base = (path || "/contestacoes").split("?")[0];
  const params = new URLSearchParams();
  params.set("embed", "1");
  return `${base}?${params.toString()}`;
}
